/**
 * Central mapping between neighborhood URL slugs and display names.
 * Slugs match the /locations/* routes in App.tsx.
 */
export const NEIGHBORHOOD_SLUG_TO_NAME: Record<string, string> = {
  arvada: "Arvada",
  aurora: "Aurora",
  "capitol-hill": "Capitol Hill",
  centennial: "Centennial",
  "central-park": "Central Park",
  "cherry-creek": "Cherry Creek",
  "cherry-hills": "Cherry Hills",
  columbine: "Columbine",
  "commerce-city": "Commerce City",
  denver: "Denver",
  dtc: "DTC",
  edgewater: "Edgewater",
  englewood: "Englewood",
  glendale: "Glendale",
  golden: "Golden",
  "greenwood-village": "Greenwood Village",
  highlands: "Highlands",
  "highlands-ranch": "Highlands Ranch",
  "ken-caryl": "Ken Caryl",
  lakewood: "Lakewood",
  littleton: "Littleton",
  "lone-tree": "Lone Tree",
  "park-hill": "Park Hill",
  rino: "RiNo",
  thornton: "Thornton",
  "wash-park": "Wash Park",
  westminster: "Westminster",
  "wheat-ridge": "Wheat Ridge",
  broomfield: "Broomfield",
  parker: "Parker",
  northglenn: "Northglenn",
  berkeley: "Berkeley",
  "sloans-lake": "Sloans Lake",
};

export function neighborhoodNameFromSlug(slug: string | null | undefined): string | null {
  if (!slug) return null;
  const key = slug.toLowerCase();
  return NEIGHBORHOOD_SLUG_TO_NAME[key] || null;
}

/** Parse neighborhood from a URL path like /locations/wash-park */
export function neighborhoodFromPath(path: string): { slug: string | null; name: string | null } {
  const m = path.match(/^\/locations\/([a-z0-9-]+)/i);
  if (!m) return { slug: null, name: null };
  const slug = m[1].toLowerCase();
  return { slug, name: neighborhoodNameFromSlug(slug) };
}
